export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/d9f26165e744ef064b81249371ce3c44.svg";